export default __webpack_public_path__ + "static/media/vippeloftmedfarge_Page_2.50df1542.png";